<!--
 * @Author: your name
 * @Date: 2021-06-22 13:58:42
 * @LastEditTime: 2021-08-30 15:21:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\home\components\EcHeaderLogout.vue
-->
<template>
  <div class="in-passWordChange">
    <!-- <div class="in-changePW flex-center" @click="toscreen">
      <p>数据大屏</p>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    toscreen() {  
      this.$router.push("/screen");
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/home/components/EcHeaderScreen.vue